__webpack_require__.p = "https://goldsync.huptechweb.com";